import React,{useEffect,useState} from "react";
import {withRouter} from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit";
import {MetaTags} from "react-meta-tags";
import axios from "axios";
import {API_URL, sitename} from "../../../constants/constants";
import toastr from "toastr";
import "toastr/build/toastr.min.css"
import {
    Button,
    Card,
    Form,
    CardBody,
    Col,
    Container,
    Row,
    Input,
    CardTitle,
    Label
} from "reactstrap";
import Breadcrumb from "../../../components/Common/Breadcrumb";

//redux
import {useSelector, useDispatch} from "react-redux";
import {DateRangeCard} from "../../EndUsers/Common/DateRangeCard";
import {
    collectSendBonus,
    depositCashierCash,
    depositEndUserCash, withdrawalCashierCash,
    withdrawalEndUserCash
} from "../../../helpers/repository";
import TableLoader from "../../../components/Common/TableLoader";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const CashierAccounts = props => {
    const dispatch = useDispatch()
    const [amount, setAmount] = useState(null)
    const [data, setData] = useState([])
    const [transactionData, setTransactionData] = useState([])
    const [loadingMessage, setLoadingMessage] = useState("1");
    const [transactionLoadingMessage, setTransactionLoadingMessage] = useState("1");
    const [searchUserId, setSearchUserId] = useState("null")

    const selectRow = {
        mode: "checkbox",
        hideSelectAll: true,
    }
    const getData = () => {
        setLoadingMessage("1");
        axios({
            method: "get",
            url: `${API_URL}/admin/get-cashiers?search=${searchUserId}`,
        })
            .then(function (response) {
                setData(response?.data?.data)
                setLoadingMessage("0");
            })
            .catch(function (response) {})
    };

    useEffect(() => {
        getData();
    }, [])

    const showTransaction = (id) => {
        setTransactionLoadingMessage("1");
        axios({
            method: "get",
            url: `${API_URL}/admin/get-end-users/${id}/get-transaction`,
        })
            .then(function (response) {
                setTransactionData(response?.data)
                setTransactionLoadingMessage("0");
            })
            .catch(function (response) {})
    }

    const [modal, setModal] = useState(false)
    const [modal1, setModal1] = useState(false)


    const { SearchBar } = Search

    const toggleViewModal = () => setModal1(!modal1)

    const deposit = (id, amount, idElement) => {
        try {
            var loggedInUser=JSON.parse(localStorage.getItem("user"))?.user?.id;
            depositCashierCash(id,loggedInUser, { amount: amount })
                .then(res => {
                    toastr.success(res?.data?.message)
                    $('#'+idElement).val('')
                    getData();
                })
                .catch(error => {
                    toastr.error(error?.response?.data?.message)
                })
        } catch (error) {
            toastr.error("Error connecting server")
        }
    }


    const withdrawal = (id, amount, idElement) => {
        try {
            var loggedInUser=JSON.parse(localStorage.getItem("user"))?.user?.id;
            withdrawalCashierCash(id,loggedInUser, { amount: amount })
                .then(res => {
                    toastr.success(res?.data?.message)
                    $('#'+idElement).val('')
                    getData();
                })
                .catch(error => {
                    toastr.error(error?.response?.data?.message)
                })
        } catch (error) {
            toastr.error("Error connecting server")
        }
    }

    const columns = [
        {
            dataField: "id",
            text: "Id",
            sort: true,
        },
        {
            dataField: "username",
            text: "Cashier",
            sort: true,
        },
        {
            dataField: "cash_balance",
            text: "Collectible",
            sort: true,
            formatter: (cellContent, row) => (
                <>{-row?.cash_balance}</>
            ),
        },
        {
            dataField: "unpaid_ticket",
            text: "Unpaid Tickets",
            sort: true,
        },
        {
            dataField: "Balance",
            text: "Balance",
            sort: true,
            formatter: (cellContent, row) => (
                <>{(row?.unpaid_ticket + row?.cash_balance).toFixed(2)}</>
            ),
        },
        {
            dataField: "MoneyTransfer",
            text: "Money Transfer",
            sort: true,

            formatter: (cellContent, row) => (
                <React.Fragment>
                    <Row className="mb-4">
                        <Col lg={10}>
                            <div className="input-group">
                                <Input
                                    type="text"
                                    className="form-control"
                                    id={`inputGroupSendMoney${row.id}`}
                                    aria-describedby="inputGroupSendMoney"
                                    placeholder="Send Money"
                                    onChange={e => {
                                        setAmount(e.target.value)
                                    }}
                                    // value={amount}
                                />
                                <button
                                    className="btn btn-success"
                                    type="button"
                                    id="inputGroupSendMoney"
                                    onClick={(event) => {
                                        deposit(row?.id, $(`#inputGroupSendMoney${row.id}`).val(),`inputGroupSendMoney${row.id}`)
                                    }}
                                >
                                    Send To
                                </button>
                            </div>
                        </Col>

                        {/* <Col lg={2}></Col> */}

                        {/* <Col lg={2}></Col> */}
                    </Row>
                    <Row className="mb-4">
                        {(row.cash_balance && row.cash_balance!=0)?
                            <Col lg={10}>
                                <div className="input-group">
                                    <Input
                                        type="text"
                                        className="form-control"
                                        id={`inputGroupCollectMoney${row.id}`}
                                        aria-describedby="inputGroupCollectMoney"
                                        placeholder="Collect Money"
                                        onChange={e => {
                                            setAmount(e.target.value)
                                        }}
                                        // value={amount}
                                    />
                                    <button
                                        type="submit"
                                        className="btn btn-danger"
                                        id="inputGroupCollectMoney"
                                        onClick={() => {
                                            withdrawal(row?.id, $(`#inputGroupCollectMoney${row.id}`).val(),`inputGroupCollectMoney${row.id}`)
                                        }}
                                    >
                                        Collect From
                                    </button>
                                </div>
                            </Col> : ''
                        }
                    </Row>

                    <Row>

                    </Row>
                </React.Fragment>
            ),
        },
        // {
        //     dataField: "Action",
        //     text: "Action",
        //     sort: true,
        //
        //     formatter: (cellContent, row) => (
        //         <React.Fragment>
        //             <Row className="mb-4">
        //                 <Col lg={10}>
        //                     <button
        //                         className="btn btn-primary"
        //                         type="button"
        //                         onClick={(event) => {
        //                             showTransaction(row?.id)
        //                         }}
        //                     >
        //                         Transactions
        //                     </button>
        //                 </Col>
        //             </Row>
        //         </React.Fragment>
        //     ),
        // },
    ]

    const transactionColumns = [
      {
        dataField: "amount",
        text: "Amount",
        sort: true,
      },
      {
        dataField: "credit_or_debit",
        text: "Credit/Debit",
        sort: true,
      },
      {
        dataField: "cash_balance",
        text: "Cash Balance",
        sort: true,
      },
      {
        dataField: "bonus_balance",
        text: "Bonus Balance",
        sort: true,
      },
      {
        dataField: "type",
        text: "Type",
        sort: true,
      },
      {
        dataField: "ticket_id",
        text: "TicketID",
        sort: true,
      },
      {
        dataField: "event",
        text: "Event",
        sort: true,
      },
      {
        dataField: "date",
        text: "Date",
        sort: true,
        formatter: (cell, row) => {
          const date = new Date(row?.date)
          const formattedDate = date.toLocaleString("en-GB", {
            timeZone: "CAT",
            hour12: true,
          })
          const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
            match.toUpperCase()
          )
          return <>{capitalizedDate}</>
        },
      },
    ]

    const defaultSorted = [
        {
            dataField: "orderId",
            order: "desc",
        },
    ]
    const defaulTransactiontSorted = [
        {
            dataField: "date",
            order: "desc",
        },
    ]

    //pagination customization
    const pageOptions = {
        sizePerPage: 6,
        totalSize: data.length,
        custom: true,
    }
    const pageTransactionOptions = {
        sizePerPage: 20,
        totalSize: transactionData.length,
        custom: true,
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{sitename}</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs title="Accounting" breadcrumbItem="Cashier Accounts" />

                    <Card>
                        <CardBody>
                            {
                                (loadingMessage && loadingMessage == "1") ?
                                    <TableLoader/> :
                                    <PaginationProvider
                                        pagination={paginationFactory(pageOptions)}
                                        keyField="id"
                                        columns={columns}
                                        data={data}
                                    >
                                        {({ paginationProps, paginationTableProps }) => (
                                            <ToolkitProvider
                                                keyField="id"
                                                data={data}
                                                columns={columns}
                                                bootstrap4
                                                search
                                            >
                                                {toolkitProps => (
                                                    <React.Fragment>
                                                        <Row className="mb-2">
                                                            <Col sm="4">
                                                                <div className="search-box me-2 mb-2 d-inline-block">
                                                                    <div className="position-relative">
                                                                        <SearchBar {...toolkitProps.searchProps} />
                                                                        <i className="bx bx-search-alt search-icon" />
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xl="12">
                                                                <div className="table-responsive">
                                                                    <BootstrapTable
                                                                        keyField="id"
                                                                        responsive
                                                                        bordered={false}
                                                                        striped={false}
                                                                        defaultSorted={defaultSorted}
                                                                        selectRow={selectRow}
                                                                        classes={
                                                                            "table align-middle table-nowrap table-check"
                                                                        }
                                                                        headerWrapperClasses={"table-light"}
                                                                        {...toolkitProps.baseProps}
                                                                        {...paginationTableProps}
                                                                        rowClasses={"mytable-hover-row"}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <div className="pagination pagination-rounded justify-content-end">
                                                            <PaginationListStandalone {...paginationProps} />
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                            </ToolkitProvider>
                                        )}
                                    </PaginationProvider>
                            }


                        </CardBody>
                        {
                            (transactionData && transactionData.length!=0) ?
                                <Card>
                                    <CardBody>
                                        {
                                            (transactionLoadingMessage && transactionLoadingMessage == "1") ?
                                                <TableLoader/> :
                                                <PaginationProvider
                                                    pagination={paginationFactory(pageTransactionOptions)}
                                                    keyField="id"
                                                    columns={transactionColumns}
                                                    data={transactionData}
                                                >
                                                    {({ paginationProps, paginationTableProps }) => (
                                                        <ToolkitProvider
                                                            keyField="id"
                                                            data={transactionData}
                                                            columns={transactionColumns}
                                                            bootstrap4
                                                        >
                                                            {toolkitProps => (
                                                                <React.Fragment>
                                                                    {/*<Row className="mb-2">*/}
                                                                    {/*    <Col sm="4">*/}
                                                                    {/*        <div className="search-box me-2 mb-2 d-inline-block">*/}
                                                                    {/*            <div className="position-relative">*/}
                                                                    {/*                <SearchBar {...toolkitProps.searchProps} />*/}
                                                                    {/*                <i className="bx bx-search-alt search-icon" />*/}
                                                                    {/*            </div>*/}
                                                                    {/*        </div>*/}
                                                                    {/*    </Col>*/}
                                                                    {/*</Row>*/}
                                                                    <Row>
                                                                        <Col xl="12">
                                                                            <div className="table-responsive">
                                                                                <BootstrapTable
                                                                                    keyField="id"
                                                                                    responsive
                                                                                    bordered={false}
                                                                                    striped={false}
                                                                                    defaultSorted={defaulTransactiontSorted}
                                                                                    // selectRow={selectRow}
                                                                                    classes={
                                                                                        "table align-middle table-nowrap table-check"
                                                                                    }
                                                                                    headerWrapperClasses={"table-light"}
                                                                                    {...toolkitProps.baseProps}
                                                                                    {...paginationTableProps}
                                                                                    rowClasses={"mytable-hover-row"}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <div className="pagination pagination-rounded justify-content-end">
                                                                        <PaginationListStandalone {...paginationProps} />
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                        </ToolkitProvider>
                                                    )}
                                                </PaginationProvider>
                                        }
                                    </CardBody>
                                </Card>
                                :''
                        }

                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(CashierAccounts)

